export default __webpack_public_path__ + "static/media/Websites.ddc01227.jpg";